import axios from 'axios'
import {fileManagerService} from '../index'
import {toast} from 'react-toastify'

class FileManager {
    getImageSignedUrl = params => fileManagerService.get('image/signed-url', {params})
    uploadFile = async(url, data) => {
        try {
            await axios.put(url, data)
            return true
        } catch (e) {
            toast.error('File cannot be uploaded. Please try later.')
            return false
        }
    }
}

export default new FileManager()
